import { useEffect, useMemo } from "react";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const VAPID_KEY =
  "BAs8aFZcPZ4xt-RwLHUY-2MMo0O0ekeeJW58rW0LL3HgsAyWym6FStR_bD3VZxjG-LSYSAC9usqXNOniQHgFU4M";

const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCg6ddeC2c7OF6W-5wJGnv_OG4hh28AKGw",
  authDomain: "proste-menu-develop.firebaseapp.com",
  projectId: "proste-menu-develop",
  storageBucket: "proste-menu-develop.firebasestorage.app",
  messagingSenderId: "766457324852",
  appId: "1:766457324852:web:5ad7a4b3707ee61a57b161",
  measurementId: "G-X53C8J95QH",
};
export const useFirebase = (): boolean => {
  const isDemoDomain = useMemo(
    () => window.location.hostname.includes("demo.proste.menu"),
    []
  );

  useEffect(() => {
    if (!isDemoDomain) {
      return;
    }

    // Check if Service Worker and Notification APIs are supported
    if (!("serviceWorker" in navigator)) {
      console.warn("Service Worker is not supported in this browser");
      return;
    }

    if (!("Notification" in window)) {
      console.warn("Notification API is not supported in this browser");
      return;
    }

    // Check if we're in a secure context (required for Service Worker)
    if (!window.isSecureContext) {
      console.warn("Service Worker requires a secure context (HTTPS)");
      return;
    }

    const app = initializeApp(FIREBASE_CONFIG);

    // Wrap getMessaging in try-catch as it may fail on unsupported platforms
    let messaging: ReturnType<typeof getMessaging>;
    try {
      messaging = getMessaging(app);
    } catch (error) {
      console.warn("Firebase Messaging is not supported in this browser:", error);
      return;
    }

    // Register service worker manually
    // Wait for service worker to be ready (registered in index.tsx)
    navigator.serviceWorker.ready
      .then(async (registration) => {

        // Request browser permission
        const permission = await Notification.requestPermission();
        if (permission === "granted") {

          try {
            const currentToken = await getToken(messaging, {
              vapidKey: VAPID_KEY,
              serviceWorkerRegistration: registration,
            });
            console.log("FCM Token:", currentToken);
            // TODO: send this token to your backend to store for later pushes
          } catch (error) {
            console.error("Failed to get FCM token:", error);
          }

        } else {
          console.warn("Notification permission denied!");
        }

        // Listen for messages while app is open
        try {
          onMessage(messaging, (payload) => {
            if (!payload.notification) return;
            const { title, body, icon } = payload.notification;
            new Notification(title ?? "", { body, icon });
          });
        } catch (error) {
          console.error("Failed to set up message listener:", error);
        }
      })
      .catch((err) => console.error("Failed to access SW:", err));
  }, [isDemoDomain]);

  return isDemoDomain;
};
